import {
  type ItemSizePredictor,
  type VirtualScrollNodesProvider,
} from '@blaze-runtime/engine-ui-feature';

export class BlazeTableItemHeightPredictor implements ItemSizePredictor<any> {
  getPredictedSize(_item: any, _index: number): number {
    return 40;
  }
}

export class BlazeTableRowsProvider implements VirtualScrollNodesProvider {
  getDOMNodes(rootElement: ChildNode): HTMLElement[] {
    const elements: HTMLElement[] = [];
    this.traverse(rootElement, elements);
    return elements;
  }

  getIndexOfElement(element: HTMLElement): number {
    const rowIndex = element.getAttribute('data-index');

    if (!rowIndex) {
      return -1;
    }

    return +rowIndex;
  }

  getSize(element: HTMLElement): number {
    return element.clientHeight;
  }

  private traverse(node: ChildNode, elements: HTMLElement[]): void {
    if (node instanceof HTMLElement && node.classList.contains('table-row')) {
      elements.push(node);
    }
    if (node.childNodes.length > 0) {
      node.childNodes.forEach((childNode) => {
        this.traverse(childNode, elements);
      });
    }
  }
}
